import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.title',
		defaultMessage: 'Project settings',
		description: 'Navigation section title.',
	},
	itemDetails: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-details',
		defaultMessage: 'Details',
		description: 'Details link item.',
	},
	itemBoards: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-boards',
		defaultMessage: 'Board',
		description: 'Board configuration link item.',
	},
	itemBoardsDirectory: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-boards-directory',
		defaultMessage: 'Boards',
		description: 'Boards Directory link item.',
	},
	itemAccess: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-access',
		defaultMessage: 'Access',
		description: 'Project access link item.',
	},
	itemIssueTypes: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-issue-types',
		defaultMessage: 'Issue types',
		description: 'Issue types link item.',
	},
	itemFieldsNonFinal: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-fields-non-final',
		defaultMessage: 'Fields',
		description: 'Fields submenu item',
	},
	automation: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.automation',
		defaultMessage: 'Automation',
		description: 'Automation link item',
	},
	itemNotifications: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-notifications',
		defaultMessage: 'Notifications',
		description: 'Notifications link item.',
	},
	itemFeatures: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-features',
		defaultMessage: 'Features',
		description: 'Features link item.',
	},
	itemOpsgenie: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-opsgenie',
		defaultMessage: 'Opsgenie',
		description: 'Opsgenie integration link item.',
	},
	itemForms: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-forms',
		defaultMessage: 'Forms',
		description: 'ProForma Forms link item.',
	},
	itemAdvancedForms: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-advanced-forms',
		defaultMessage: 'Advanced Forms',
		description: 'ProForma Forms link item.',
	},
	itemConnections: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-connections',
		defaultMessage: 'Connections',
		description: 'DevOps connections link item.',
	},
	dataClassificationNonFinal: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.data-classification-non-final',
		defaultMessage: 'Data classification',
		description: 'Data classification link item within data protection sub-menu',
	},
	itemIssueTypesIssueTermRefresh: {
		id: 'spa-apps-sidebar-next-gen.menu.settings.item-issue-types-issue-term-refresh',
		defaultMessage: 'Work types',
		description: 'Issue types link item.',
	},
});
